/**
 * useCurrencyOptions — returns the CURRENCIES list re-ordered so the
 * common ones surface at the top:
 *
 *   INR · USD · CAD · GBP · EUR · AUD · SGD · AED
 *
 * …then everything else alphabetically by code. Codes not in CURRENCIES
 * are dropped silently.
 *
 * Kept as a tiny hook so any form can consume it without duplicating
 * the ordering logic.
 */
import { useMemo } from 'react';
import { CURRENCIES } from '@/lib/format';

const TOP = ['INR', 'USD', 'CAD', 'GBP', 'EUR', 'AUD', 'SGD', 'AED'];

export default function useCurrencyOptions() {
  return useMemo(() => {
    const byCode = new Map(CURRENCIES.map((c) => [c.code, c]));
    const top = TOP.map((code) => byCode.get(code)).filter(Boolean);
    const rest = CURRENCIES
      .filter((c) => !TOP.includes(c.code))
      .sort((a, b) => a.code.localeCompare(b.code));
    return { top, rest, all: [...top, ...rest] };
  }, []);
}
